import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowLeft, 
  FaAward, 
  FaUniversity, 
  FaFlask, 
  FaUsers, 
  FaMedal, 
  FaTrophy,
  FaStar,
  FaChartLine,
  FaCalendarAlt
} from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const Tubitak1001Sonuclari = () => {
  const pageTitle = "TÜBİTAK 1001 Programı Sonuçları";
  const pageSubtitle = "2025 Yılı 1. Dönem Değerlendirme Sonuçları Açıklandı";

  const acceptedFaculty = [
    {
      name: "Prof. Dr. Mahmut Kabalak",
      department: "Biyoloji",
      photo: "https://avesis.hacettepe.edu.tr/user/image/7144"
    },
    {
      name: "Prof. Dr. Nuray Şatıroğlu",
      department: "Kimya",
      photo: "https://avesis.hacettepe.edu.tr/user/image/6440"
    },
    {
      name: "Öğr. Gör. Dr. Güzin Emecen",
      department: "Biyoloji",
      photo: "https://avesis.hacettepe.edu.tr/user/image/6001"
    },
    {
      name: "Prof. Dr. Solmaz Karabulut Şehitoğlu",
      department: "Kimya",
      photo: "https://avesis.hacettepe.edu.tr/user/image/5788"
    }
  ];

  const stats = [
    {
      number: "21",
      label: "Kabul Edilen Proje",
      description: "Hacettepe Üniversitesi",
      icon: FaFlask,
      gradient: "from-blue-500 to-blue-700"
    },
    {
      number: "3",
      label: "İlk 3'te",
      description: "Devlet Üniversiteleri Arasında",
      icon: FaTrophy,
      gradient: "from-amber-500 to-amber-700"
    },
    {
      number: "4",
      label: "Fen Fakültesi",
      description: "Kabul Edilen Proje",
      icon: FaUniversity,
      gradient: "from-green-500 to-green-700"
    }
  ];

  return (
    <PageTemplate
      title={pageTitle}
      subtitle={pageSubtitle}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Ana İçerik */}
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl -mt-16 relative z-10 mb-16">
          
          {/* Tarih ve Kategori Bilgisi */}
          <div className="flex flex-wrap items-center gap-4 mb-8 pb-6 border-b border-gray-100">
            <div className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-full border border-blue-100">
              <FaCalendarAlt className="text-blue-600 text-sm" />
              <span className="text-blue-700 font-medium text-sm">14 Ağustos 2025</span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-purple-50 to-violet-50 rounded-full border border-purple-100">
              <FaAward className="text-purple-600 text-sm" />
              <span className="text-purple-700 font-medium text-sm">TÜBİTAK ARDEB</span>
            </div>
          </div>

          {/* İstatistik Kartları */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="group relative overflow-hidden bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${stat.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
                <div className="relative">
                  <div className={`inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br ${stat.gradient} rounded-xl mb-4 text-white`}>
                    <stat.icon className="text-xl" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-3xl font-bold text-gray-800 group-hover:text-gray-900 transition-colors">
                      {stat.number}
                    </h3>
                    <p className="text-lg font-semibold text-gray-700">{stat.label}</p>
                    <p className="text-sm text-gray-500">{stat.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Ana Haber İçeriği */}
          <div className="prose prose-lg max-w-none mb-12">
            <div className="bg-gradient-to-r from-blue-50/80 to-indigo-50/80 p-8 rounded-2xl border-l-4 border-blue-500 mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <FaMedal className="text-blue-600 mr-3" />
                TÜBİTAK-ARDEB 1001 Programı Başarısı
              </h2>
              
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                <span className="font-semibold text-blue-700">TÜBİTAK Araştırma Destek Programları Başkanlığı (ARDEB)</span> 
                tarafından yürütülen <span className="font-semibold">"1001-Bilimsel ve Teknolojik Araştırma Projelerini Destekleme Programı"</span> nın 
                <span className="font-semibold text-indigo-700"> 2025 yılı 1. dönem sonuçları</span> açıklanmıştır.
              </p>
              
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                Yapılan değerlendirme neticesinde <span className="font-bold text-hacettepe-blue">Üniversitemizden sunulan 21 proje önerisi</span> 
                desteklenmeye hak kazanmıştır. Bu sonuç ile 
                <span className="font-bold text-hacettepe-red"> Hacettepe Üniversitesi, proje başvurusu kabul edilen devlet üniversiteleri arasında ilk üçte</span> 
                yer almıştır.
              </p>
            </div>
          </div>

        </div>

        {/* Fen Fakültesi Başarı Bölümü */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold text-gray-800 mb-4 tracking-tight">
              🎯 Fen Fakültesi Başarısı
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-hacettepe-blue to-hacettepe-red mx-auto rounded-full mb-4"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Bu başarı kapsamında, Fen Fakültesi bünyesindeki değerli öğretim elemanlarımızın projeleri desteklenmiştir
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {acceptedFaculty.map((faculty, index) => (
              <div 
                key={index}
                className="group relative bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-hacettepe-blue/20 overflow-hidden"
              >
                {/* Background gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-hacettepe-blue/5 to-hacettepe-red/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative">
                  <div className="flex items-start space-x-4 mb-4">
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 rounded-2xl overflow-hidden ring-2 ring-hacettepe-blue/20 group-hover:ring-hacettepe-blue/40 group-hover:scale-110 transition-all duration-300">
                        <img
                          src={faculty.photo}
                          alt={faculty.name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div className="w-full h-full bg-gradient-to-br from-hacettepe-blue to-blue-600 rounded-2xl hidden items-center justify-center text-white text-2xl font-bold">
                          👨‍🏫
                        </div>
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-xl font-bold text-gray-800 group-hover:text-hacettepe-blue transition-colors duration-300 mb-2">
                        {faculty.name}
                      </h3>
                      <p className="text-gray-600 font-medium flex items-center">
                        <FaUniversity className="mr-2 text-hacettepe-blue" />
                        {faculty.department} Bölümü
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100 group-hover:border-hacettepe-blue/20 transition-colors">
                    <div className="flex items-center space-x-2">
                      <FaStar className="text-yellow-500" />
                      <span className="text-sm font-medium text-gray-600">Proje Kabul Edildi</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <div 
                          key={i}
                          className={`w-2 h-2 rounded-full ${i < 4 ? 'bg-hacettepe-blue' : 'bg-gray-200'} group-hover:bg-hacettepe-red transition-colors duration-300`}
                          style={{ transitionDelay: `${i * 100}ms` }}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>
                
                {/* Hover decoration */}
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-3 h-3 bg-hacettepe-blue rounded-full animate-pulse"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tebrik Mesajı */}
        <div className="mb-16">
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-8 md:p-12 rounded-3xl border border-green-100 text-center">
            <div className="max-w-3xl mx-auto">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                  <FaAward className="text-3xl text-white" />
                </div>
              </div>
              
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
                🎉 Tebrikler!
              </h3>
              
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                <span className="font-semibold text-green-700">Projesi kabul edilen değerli akademisyenlerimizi</span> tebrik eder, 
                <span className="font-semibold text-emerald-700"> çalışmalarında başarılar</span> dileriz.
              </p>
              
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                {['🔬', '📚', '⚡', '🎯', '💡'].map((emoji, index) => (
                  <div 
                    key={index}
                    className="w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center text-xl hover:scale-110 transition-transform duration-300"
                    style={{ animationDelay: `${index * 200}ms` }}
                  >
                    {emoji}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Geri Dön Butonu */}
        <div className="text-center">
          <Link 
            to="/haberler" 
            className="group inline-flex items-center px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300"
          >
            <FaArrowLeft className="mr-3 -ml-1 h-5 w-5 group-hover:-translate-x-1 transition-transform duration-300" />
            Tüm Haberlere Geri Dön
          </Link>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Tubitak1001Sonuclari;
